import "./styles.scss";
import { MEDIA_APPROVADED, MEDIA_DISABLE, MEDIA_ENABLE } from "../../API/mediaApi";
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useEffect } from "react";
import logo from "../../assets/logo_bizsys.png";

export function Card({
  active,
  approved,
  campain_name,
  cpf,
  fk_id_media_type,
  id,
  participation,
  phone,
  url,
  file,
  getMedia,
}) {
  function iOS() {
    return (
      [
        "iPad Simulator",
        "iPhone Simulator",
        "iPod Simulator",
        "iPad",
        "iPhone",
        "iPod",
      ].includes(navigator.platform) ||
      // iPad on iOS 13 detection
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)
    );
  }

  const token = window.localStorage.getItem("token");
  const user = JSON.parse(window.localStorage.getItem("user"));

  const [approvedCard, setApprovedCard] = useState(approved);
  const [activeCard, setActiveCard] = useState(active);

  async function handleApproved(id, phone, approvedOrNot) {
    const { url, options } = MEDIA_APPROVADED(id, token, {
      approved: approvedOrNot,
      phone,
    });

    try {
      const res = await fetch(url, options);
      const json = await res.json();

      if (!res.ok) {
        return notify();
      }

      setApprovedCard(json.data.approved);
    } catch (err) {
      notify();
    }
  }

  async function disableMedia(id) {
    const { url, options } = MEDIA_DISABLE(id, token);

    try {
      const res = await fetch(url, options);
      const json = await res.json();

      if (!res.ok) {
        return notify();
      }

      setActiveCard(0);
    } catch (err) {
      notify();
    }
  }

  async function enableMedia(id) {
    const { url, options } = MEDIA_ENABLE(id, token);

    try {
      const res = await fetch(url, options);
      const json = await res.json();

      if (!res.ok) {
        return notify();
      }

      setActiveCard(1);
    } catch (err) {
      notify();
    }
  }

  function formatedDate(date) {
    const newDate = new Date(date.replace(/\s/, "T"));

    const dateFormated = `${newDate.getDate()}/${
      newDate.getMonth() + 1
    }/${newDate.getFullYear()} - ${newDate.getHours()}:${newDate.getMinutes()}`;

    return dateFormated;
  }

  const notify = () =>
    toast.error("Houve um erro na requisição, tente novamente mais tarde.");

  return (
    <>
      <ToastContainer theme="dark" />
      <div className="col-md-3 mediaContainer fadeIn">
        <header>
          <div className="media">
            {fk_id_media_type === 1 && (
              <img className="img-fluid" src={url} alt="projeto" />
            )}
            {fk_id_media_type === 3 && (
              <img className="img-fluid" src={url} alt="projeto" />
            )}
            {fk_id_media_type === 2 && (
              <video controls poster={iOS() ? logo : null}>
                <source src={url} type="video/mp4" alt="projeto" />
              </video>
            )}
            {fk_id_media_type === 4 && (
              <div className="textBox ">
                <p>{file}</p>
              </div>
            )}
          </div>
          <div className="status">
            {approvedCard === 0 && (
              <span className="pending fadeIn">Pendente</span>
            )}

            {approvedCard === 1 && (
              <span className="approved fadeIn">Aprovado</span>
            )}
            {approvedCard === 2 && (
              <span className="disapproved fadeIn">Reprovado</span>
            )}

            {user?.fk_id_type === 1 && activeCard === 1 && (
              <button
                className="activate fadeIn"
                onClick={() => disableMedia(id)}
                title="Ativar Desativar"
              >
                <i className="far fa-check-circle"></i>
              </button>
            )}

            {user?.fk_id_type === 1 && activeCard === 0 && (
              <button
                className="disable fadeIn"
                onClick={() => enableMedia(id)}
                title="Ativar Media"
              >
                <i className="fas fa-ban"></i>
              </button>
            )}
          </div>
        </header>

        <div className="cardBody">
          <ul>
            <li>#{id}</li>
            <li>Projeto: {campain_name}</li>
            <li>
              <p>ID: {cpf}</p>
            </li>
            <li>Celular: {phone}</li>
            <li>Data: {formatedDate(participation)}</li>
          </ul>
        </div>

        <footer>
          {approvedCard === 0 && (
            <button
              className="approvedButton "
              onClick={() => handleApproved(id, phone, 1)}
              title="Aprovar"
            >
              Aprovar
            </button>
          )}
          {approvedCard === 0 && (
            <button
              className="disapprovedButton"
              onClick={() => handleApproved(id, phone, 2)}
              title="Reprovar"
            >
              Reprovar
            </button>
          )}
        </footer>
      </div>
    </>
  );
}
